import { SingleProductTileActionTypes } from '../../../enums/ActionEnums';
export const singleProductTileActions = {
    addProductToList: (payload) => ({
        type: SingleProductTileActionTypes.ADD_PRODUCT_TO_LIST,
        payload,
    }),
    addBulkProductsToList: (payload) => ({
        type: SingleProductTileActionTypes.ADD_BULK_PRODUCTS_TO_LIST,
        payload,
    }),
    getDeliveryPromise: (payload) => ({
        type: SingleProductTileActionTypes.GET_DELIVERY_PROMISE,
        payload,
    }),
    setDeliveryPromise: (payload) => ({
        type: SingleProductTileActionTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
};
